<div ng-controller="emailGroupDetailsController as ctrl" class="modal-view email-group-details-management">
    <c-auto-form config="ctrl.autoFormConfig"></c-auto-form>
</div>